import { render } from "./EditCampaign.vue?vue&type=template&id=abca10c4"
import script from "./EditCampaign.vue?vue&type=script&lang=js"
export * from "./EditCampaign.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Cesar\\Documents\\Proyectos\\POSVitialife\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__